import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import useAuth from '../../hooks/useAuth'
import OnboardingStepNav from './Partials/OnboardingStepNav'
import PersonalDetails from './Partials/PersonalDetails'
import Address from './Partials/Address'
import HealthInfo from './Partials/HealthInfo'
import OnboardingComplete from './Partials/OnboardingComplete'
import { info } from 'autoprefixer'
import { toast } from 'sonner'

const Onboarding = ({
  setShowOnboardingCompletedModal,
  setShowOnboardingModal,
  dependant = false,
}) => {
  const location = useLocation()
  const passedContact = location.state?.contact
  const { orgDetails, setOrgDetails } = useAuth()
  const currentOrgDetails = location.state || orgDetails
  const [isDependant, setIsDependant] = useState(dependant)
  const navigate = useNavigate()
  const axios = useAxiosPrivate()
  const { setShowLoader, createInfo, auth } = useAuth()
  const [under16, setUnder16] = useState(false)
  const [tempDependant, setTempDependant] = useState(null)

  const getInitialStep = () => {
    if (dependant) {
      return 1
    }
    const completedStep = auth?.user?.user_info?.onboarding_step_completed
    switch (completedStep) {
      case 'personal_details':
        return 2
      case 'address':
        return 3
      default:
        return 1
    }
  }

  const [step, setStep] = useState(getInitialStep())
  const [isValid, setIsValid] = useState(false)

  const [personalDetails, setPersonalDetails] = useState({
    firstName: dependant ? '' : auth?.user?.name?.split(' ')[0] || '',
    surname: dependant ? '' : auth?.user?.name?.split(' ')[1] || '',
    dob: dependant ? '' : auth?.user?.date_of_birth || '1990-01-01',
    phone: dependant ? '' : auth?.user?.phone_number || '',
    title: dependant ? '' : auth?.user?.user_info?.title || '',
    sexAssigned: dependant ? '' : auth?.user?.user_info?.gender || '',
    email: dependant ? '' : auth?.user?.email || '',
    phone_number: dependant ? '' : auth?.user?.phone_number || '',
  })

  const [gpData, setGpData] = useState({
    name: auth?.user?.user_info?.gp?.name || '',
    addressLine1: auth?.user?.user_info?.gp?.address?.addressLine1 || '',
    addressLine2: auth?.user?.user_info?.gp?.address?.addressLine2 || '',
    postcode: auth?.user?.user_info?.gp?.address?.postcode || '',
    city: auth?.user?.user_info?.gp?.address?.city || '',
    phone: auth?.user?.user_info?.gp?.phone || '',
  })

  const [userAddress, setUserAddress] = useState({
    addressLine1: auth?.user?.user_info?.address?.addressLine1 || '',
    addressLine2: auth?.user?.user_info?.address?.addressLine2 || '',
    postcode: auth?.user?.user_info?.address?.postcode || '',
    city: auth?.user?.user_info?.address?.city || '',
    phone: auth?.user?.phone_number || '',
  })

  const [healthInfo, setHealthInfo] = useState({})

  useEffect(() => {
    setOrgDetails(currentOrgDetails)
  }, [currentOrgDetails, orgDetails, setOrgDetails, navigate])


  useEffect(() => {
    if (auth?.user?.user_info?.onboarding_step_completed) {
      const newStep = getInitialStep()
      setStep(newStep)
    }
  }, [auth?.user?.user_info?.onboarding_step_completed])


  useEffect(() => {
    let completedStep = auth?.user?.user_info?.onboarding_step_completed

    if (dependant) {
      completedStep = null
    }



    if (step === 2 && completedStep === 'personal_details') {
      setIsValid(true)
    } else if (step === 3 && completedStep === 'address') {
      setIsValid(true)
    } else {
      setIsValid(false)
    }
  }, [step, auth?.user?.user_info?.onboarding_step_completed])

  const handlePersonalDetailsChange = (field, value) => {
    setPersonalDetails((prev) => ({
      ...prev,
      [field]: value,
    }))
  }

  const handleHealthInfoChange = (field, value) => {
    setHealthInfo((prev) => ({
      ...prev,
      [field]: value,
    }))
  }

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <PersonalDetails
            data={personalDetails}
            onChange={handlePersonalDetailsChange}
            onValidityChange={setIsValid}
            dependant={dependant}
            setUnder16={setUnder16}
          />
        )
      case 2:
        return (
          <Address
            data={userAddress}
            gpData={gpData}
            onChange={(field, value) =>
              setUserAddress((prev) => ({ ...prev, [field]: value }))
            }
            onGpChange={(value) => setGpData(value)}
            onValidityChange={setIsValid}
            dependant={dependant}
          />
        )
      case 3:
        return (
          <HealthInfo
            data={healthInfo}
            onChange={handleHealthInfoChange}
            onValidityChange={setIsValid}
            dependant={dependant}
          />
        )
      case 4:
        return <OnboardingComplete dependant={dependant} />
      default:
        return null
    }
  }

  const RenderStepButton = () => {
    let buttonText = 'Next';

    if (dependant && !under16) {
      buttonText = 'Send Link';
    } else if (step === 4) {
      buttonText = 'Finish';
    }

    const handleClick = async (buttonText) => {
      setShowLoader(true)
      if (buttonText === "Send Link") {
        try {
          setShowLoader(true)
          axios.post('/onboarding/dependant-link', { details: personalDetails, userId: auth?.user?.id });
          toast.success('Dependant link sent successfully')
          setShowOnboardingModal(false)
          setShowLoader(false)
        } catch (error) {
          console.error('Error sending dependant link:', error)
          setShowLoader(false)
          return

        }

      } else {
        try {
          switch (step) {
            case 1:
              try {
                const response = await axios.post(
                  '/onboarding/personal-details',
                  {
                    details: personalDetails,
                    dependant: dependant,
                    id: auth?.user?.id,
                    onboarding_step_completed: 'personal_details',
                  }
                )
                if (dependant) {
                  setTempDependant(response.data.result)
                  localStorage.setItem('dependant', response.data.result.id)
                }
              } catch (error) {
                console.error('Error submitting personal details:', error)
                setShowLoader(false)
                return
              }
              break

            case 2:
              try {
                const response = await axios.post('/onboarding/address', {
                  address: userAddress,
                  dependant: dependant,
                  gp: gpData,
                  id: dependant
                    ? localStorage.getItem('dependant')
                    : auth?.user?.id,
                  onboarding_step_completed: 'address',
                })

                if (dependant) {
                  setTempDependant(response.data.result)
                  localStorage.setItem('dependant', response.data.result.id)
                }
              } catch (error) {
                console.error('Error submitting address details:', error)
                setShowLoader(false)
                return
              }
              break

            case 3:
              try {
                await axios.post('/onboarding/health-info', {
                  info: healthInfo,
                  dependant: dependant,
                  id: dependant
                    ? localStorage.getItem('dependant')
                    : auth?.user?.id,
                  onboarding_step_completed: 'completed',
                })
                setShowOnboardingModal(false)
                localStorage.removeItem('dependant')
                setShowOnboardingCompletedModal(true)
                setShowLoader(false)
              } catch (error) {
                console.error('Error submitting health info:', error)
                setShowLoader(false)
                return
              }
              return
            default:
              setShowLoader(false)
              return
          }


          setStep((prev) => prev + 1)
          setIsValid(false)
          setShowLoader(false)
        } catch (error) {
          console.error(`Unexpected error at step ${step}:`, error)
          setShowLoader(false)
        }
      }

    }

    return (
      <button
        type="button"
        onClick={() => { handleClick(buttonText) }}
        disabled={
          buttonText === "Send Link"
            ? false
            : !isValid
        }
        className={`inline-flex justify-center rounded-md px-3 py-2 font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-300 ${buttonText === "Send Link"
            ? 'bg-hub-primary hover:bg-hub-primary-hover'
            : !isValid
              ? 'bg-gray-300 cursor-not-allowed'
              : 'bg-hub-primary hover:bg-hub-primary-hover'
          }`}
      >
        {buttonText}
      </button>
    )
  }

  const [cancelClickedOnce, setCancelClickedOnce] = useState(false)

  return (
    <section>
      <div className="flex-1 xl:overflow-y-auto pb-5 max-w-4xl mx-auto">
        <div className="flex items-center justify-center border-b border-gray-300 pb-4 mb-8">
          <OnboardingStepNav
            step={step}
            completedStep={
              dependant
                ? tempDependant?.user_info?.onboarding_step_completed
                : auth?.user?.user_info?.onboarding_step_completed
            }
          />
        </div>

        <form className="divide-y divide-slate-200">
          <div className="pb-8">{renderStep()}</div>

          {step !== 4 && (
            <div className="flex justify-between gap-x-3 pt-8">
              <div>
                {step > 1 && (
                  <button
                    type="button"
                    onClick={() => {
                      const newStep = step - 1
                      setStep(newStep)


                      const completedStep =
                        auth?.user?.user_info?.onboarding_step_completed
                      const isStepCompleted =
                        (newStep === 1 &&
                          (completedStep === 'personal_details' ||
                            completedStep === 'address' ||
                            completedStep === 'completed')) ||
                        (newStep === 2 &&
                          (completedStep === 'address' ||
                            completedStep === 'completed'))

                      setIsValid(isStepCompleted)
                    }}
                    className="rounded-md bg-white px-3 py-2 text-sm font-semibold shadow-sm ring-1 ring-inset ring-slate-300 hover:bg-slate-50"
                  >
                    Back
                  </button>
                )}
                {dependant && step === 1 && (
                  <div>
                    <button
                      type="button"
                      onClick={() => {
                        if (cancelClickedOnce) {
                          setShowOnboardingModal(false)
                        } else {
                          setCancelClickedOnce(true)
                        }
                      }}
                      className="rounded-md bg-white px-3 py-2 text-sm font-semibold shadow-sm ring-1 ring-inset ring-slate-300 hover:bg-slate-50"
                    >
                      {cancelClickedOnce ? 'Confirm Cancel' : 'Cancel'}
                    </button>
                    {cancelClickedOnce && (
                      <p className="text-sm text-red-600 mt-2">
                        By cancelling you will lose the progress. Click again to confirm.
                      </p>
                    )}
                  </div>
                )}
              </div>
              <div>
                <RenderStepButton />
              </div>
            </div>
          )}
        </form>
      </div>
    </section>
  )
}

export default Onboarding
